<template>
  <div
    class="mobile-sidebar catalog-sidebar row"
    data-sidebar="catalog-categories"
  >
    <button
      class="btn btn-link close-sidebar-button d-md-none"
      @click="closeAllSidebars"
    >
      <icon-close />
    </button>
    <button
      class="btn btn-link page-back-button d-none d-md-none"
      @click="sidebarPageBack"
    >
      <icon-chevron-left />
    </button>
    <div ref="container" class="container">
      <div class="row main-section section-categories">
        <div class="col sidebar-main-page">
          <h3 class="page-heading mb-2">{{ gettext('Categorieën') }}</h3>
          <div class="page-content category-list">
            <HierarchicalMenu
              v-for="s in activeSections"
              :key="s"
              :section="s"
              :title="sections[s].title"
              :show-title="activeSections.length > 1"
              :show-list="section === s"
              :attributes="sections[s].attributes"
              :limit="30"
              list-class="expandable-list limit-10"
              sub-list-class="subcategory-list expandable-list limit-5"
              :transform-items="sections[s].transformItems"
              :clear-refinement-attributes="
                $store.state.excludedClearRefinements
              "
              @onSelectItem="onSelectItem(s)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HierarchicalMenu from './HierarchicalMenu.vue';
import IconClose from '../../../../templates/icons/close.svg';
import IconChevronLeft from '../../../../templates/icons/chevron-left.svg';

export default {
  components: {
    HierarchicalMenu,
    IconClose,
    IconChevronLeft,
  },
  data() {
    return {
      currentSectionSlug:
        this.$route.params.section || this.$route.query.section,
      sections: {
        women: {
          title: this.gettext('women'),
          attributes: ['women_categories.lvl0', 'women_categories.lvl1'],
          transformItems: items => this.transformItems('women', items),
        },
        men: {
          title: this.gettext('men'),
          attributes: ['men_categories.lvl0', 'men_categories.lvl1'],
          transformItems: items => this.transformItems('men', items),
        },
        kids: {
          title: this.gettext('kids'),
          attributes: ['kids_categories.lvl0', 'kids_categories.lvl1'],
          transformItems: items => this.transformItems('kids', items),
        },
        home: {
          title: this.gettext('home'),
          attributes: ['home_categories.lvl0', 'home_categories.lvl1'],
          transformItems: items => this.transformItems('home', items),
        },
        'beauty-care': {
          title: this.gettext('beauty & care'),
          attributes: [
            'beauty-care_categories.lvl0',
            'beauty-care_categories.lvl1',
          ],
          transformItems: items => this.transformItems('beauty-care', items),
        },
      },
    };
  },
  computed: {
    section() {
      // return this.currentSectionSlug;
      return this.$store.getters.sectionSlugToIdMap[
        this.$route.params.section || this.$route.query.section
      ];
      // console.log("computed section:", this.$route.params.section || this.$route.query.section);
      // return this.$route.params.section || this.$route.query.section;
    },
    showAllSections() {
      return this.$route.name !== 'catalog';
    },
    activeSections() {
      if (this.showAllSections) {
        return Object.keys(this.sections);
      }
      return [this.section];
    },
  },
  mounted() {
    this.setupMinHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setMinHeight);
  },
  methods: {
    setupMinHeight() {
      this.setMinHeight();
      window.addEventListener('resize', this.setMinHeight);
    },
    setMinHeight() {
      this.$refs.container.style.minHeight = 'auto';
      this.$refs.container.style.minHeight =
        this.$refs.container.clientHeight + 'px';
    },
    closeAllSidebars() {
      window.closeAllSidebars();
    },
    sidebarPageBack() {
      window.sidebarPageBack();
    },
    onSelectItem() {
      this.closeAllSidebars();
    },

    getLabelByPath(section, path, split) {
      /**
       * Gets the label for a category or subcategory.
       *
       * The method takes three arguments:
       *
       * * section: The section of the catalog that the category or subcategory
       *   belongs to.
       * * path: The path of the category or subcategory in the database.
       * * split: A boolean value that indicates whether or not the path should be
       *   split into a category and a subcategory.
       *
       * If the split argument is false, the method will simply return the name of
       * the category or subcategory. If the split argument is true, the method will
       * split the path into a category and a subcategory and then return the name
       * of the subcategory.
       *
       * Args:
       *   section: The section of the catalog that the category or subcategory
       *     belongs to.
       *   path: The path of the category or subcategory in the database.
       *   split: A boolean value that indicates whether or not the path should be
       *     split into a category and a subcategory.
       *
       * Returns:
       *   The label for the category or subcategory.
       */

      // Root category, there is no need to split the path as it is
      // only the name of the category
      if (!split) {
        if (!this.$store.state.categories[section].c[path]) {
          console.error(`No category found for algolia category '${path}'`);
          return path;
        }
        return this.$store.state.categories[section].c[path].name;
      }

      // Not a root category, format of path is: "category > subcategory"
      // split it and figure out the right label
      const parts = path.split(' > ');
      if (!this.$store.state.categories[section].c[parts[0]]) {
        console.error(`No category found for algolia category '${parts[0]}'`);
        // Return false so that this subcategory can be removed later
        return false;
      }
      if (!this.$store.state.categories[section].c[parts[0]].s[parts[1]]) {
        console.error(
          `No subcategory found for algolia subcategory '${parts[1]}'`
        );
        // Return false so that this subcategory can be removed later
        return false;
      }
      return this.$store.state.categories[section].c[parts[0]].s[parts[1]].name;
    },
    transformItems(section, items) {
      /**
       * Transforms the items in the given section.
       *
       * The function takes two arguments:
       *
       * * section: The section of the catalog that the items belong to.
       * * items: The items to be transformed.
       *
       * The function returns an array of transformed items.
       */
      if (!this.$store.state.categories[section]) {
        return [];
      }
      const categories = Object.keys(this.$store.state.categories[section]);
      let returndata = items
        .filter(item => !!this.$store.state.categories[section].c[item.value])
        .map(item => {
          // Get translation of category ID
          item.label = this.getLabelByPath(section, item.value, false);
          if (item.data) {
            item.data = item.data
              .map(i => {
                // Convert algolia path format ("category ID > subcategory ID") to translated label
                i.label = this.getLabelByPath(section, i.value, true);
                return i;
              })
              // Remove all subcategories of which no translation was available
              .filter(i => i.label !== false)
              // Sort subcategories on number of entries
              .sort((a, b) => b.count - a.count);
          }
          return item;
        })
        // Remove all categories of which no translation was available
        .filter(i => i.label !== false)
        // Sort based on the order of the categories in the database
        .sort((a, b) => {
          return categories.indexOf(b.value) - categories.indexOf(a.value);
        });
      return returndata;
    },
  },
};
</script>
